import { render, staticRenderFns } from "./Curadoria.vue?vue&type=template&id=079a9b79&scoped=true"
import script from "./Curadoria.vue?vue&type=script&lang=js"
export * from "./Curadoria.vue?vue&type=script&lang=js"
import style0 from "./Curadoria.vue?vue&type=style&index=0&id=079a9b79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079a9b79",
  null
  
)

export default component.exports